export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/7a143c79cdc7d4c413ea4cb40505b1e6.png";